import { uniqueId } from 'lodash'
import { useContext, useEffect, useRef } from 'react'
import Renderer from '../../../../../artboard-gl/classes/renderer'
import Shader from '../../../../../artboard-gl/classes/shader'
import { ArtboardFilter } from '../../../../../artboard-gl/types'
import { UGEContext } from '../../../../context'
import { labelFromArtboardFilter } from '../../../../utilities/artboard-filter'
import { Canvas, Label, Preview } from './style'

const PREVIEW_CANVAS_SIZE = 75

type Props = {
    active?: boolean
    className?: string
    filter?: ArtboardFilter
    onClick: (filter?: ArtboardFilter) => void
}

const UGEFiltersEditorPreview = ({ active = false, className, filter, onClick }: Props) => {
    const { thumbnail } = useContext(UGEContext)
    const idRef = useRef<string>(uniqueId('uge-filter-editor-preview-'))
    const canvasRef = useRef<HTMLCanvasElement>(null)

    useEffect(() => {
        if (!canvasRef.current || !thumbnail) return

        const canvas = canvasRef.current

        canvas.width = PREVIEW_CANVAS_SIZE
        canvas.height = canvas.width

        const context = canvas.getContext('webgl')
        const renderer = new Renderer(context!)
        const shader = new Shader(renderer.gl, filter)
        const texture = renderer.createTexture(thumbnail)

        renderer.setNodes([
            {
                id: idRef.current,
                draw: () => {
                    const aspectRatio = thumbnail.width / thumbnail.height
                    let width = canvas.width
                    let height = Math.round(width / aspectRatio)

                    if (height < canvas.height) {
                        height = canvas.height
                        width = Math.round(height * aspectRatio)
                    }

                    shader.setIntensity(1)
                    shader.setProgress(0.5)

                    shader.drawImage({
                        height,
                        texture,
                        width,
                        x: Math.round((canvas.width - width) / 2),
                        y: Math.round((canvas.height - height) / 2),
                    })
                },
            },
        ])

        renderer.render()
    }, [canvasRef, filter, thumbnail])

    return (
        <Preview active={active} className={className}>
            <Canvas ref={canvasRef} onClick={() => onClick(filter)} />
            <Label>{labelFromArtboardFilter(filter)}</Label>
        </Preview>
    )
}

export default UGEFiltersEditorPreview
